module.exports = __webpack_public_path__ + "img/app-store.f8f87a03.svg";